import React from 'react';

function Hero() {
    return (
        <div>
            <img src={"kiedy-smieci.jpg"} className="center logo" alt={"Kiedy śmieci?"}/>
            <h1 className="headline text-4xl font-bold text-center text-gray-900 mb-12">
                Kiedy <span>śmieci?</span>
            </h1>
        </div>
    );
}

export default Hero;
